/* import 'material-design-icons-iconfont/dist/material-design-icons.css' */




import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';

import api from './api'

import moneyFilter from './filters/moneyFilter'
import rubleFilter from './filters/rubleFilter'


import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

Vue.config.productionTip = false


import SgLoader from './components/common/SgLoader'
import SgTextField from './components/common/SgTextField'
import SgSwitch from './components/common/SgSwitch'
import SgNavBackBtn from './webview/SgNavBackBtn'
import SgItemsBlock from './components/common/SgItemsBlock'
import store from './store'

Vue.component('sg-loader', SgLoader)
Vue.component('sg-text-field', SgTextField)
Vue.component('sg-switch', SgSwitch)
Vue.component('sg-nav-back-btn', SgNavBackBtn)
Vue.component('sg-items-block', SgItemsBlock)


const options = { platform: '' }

const options2 = new Vue({
  data: {

    options: {
      ui: {
        showBack: false
      },
      mocks: {
      
      }
    }
   
  }
})

const eventBus = new Vue()
Object.defineProperty(Vue.prototype, '$eventBus', {
  get () {
    return eventBus
  }
})

Object.defineProperty(Vue.prototype, '$api', {
  get () {
    return api
  }
})

Object.defineProperty(Vue.prototype, '$sg', {
  get () {
    return options2
  }
})


const logger = new Vue({

  data() {
    return {
      silent: process.env.NODE_ENV === 'production', 
    }
  },

  methods: {
    log() {
      /*     if (!this.silent) {
            console.log(arguments)
          } */
      
          this.write(arguments)
        },
      
        write() {
          if (!this.silent) {
            console.log(arguments)
          }
        },
      
        error() {
          if (!this.silent) {
            console.log(arguments)
          }
        }
  }

  
  
 
})

Object.defineProperty(Vue.prototype, '$logger', {
  get () {
    return logger
  }
})


Vue.filter('fin', moneyFilter)
Vue.filter('rub', rubleFilter)


Vue.filter('tel', function(value, options) {

  const opts = {
    mask: false,
    empty: '',
    error: '',
    prefix: '+7 '
  }

  options = Object.assign(opts, options)


  if (!value) return options.empty

  value = value.toString()

  if (value.length != 10) return options.error

  if (options.mask === true) {
    return options.prefix + '*** *** ' +
    value.slice(6, 8) +
    '-' + value.slice(8, 10)
  }

  return `${options.prefix}${value.slice(0, 3)} ${value.slice(3, 6)} ${value.slice(6, 8)}-${value.slice(8, 10)}`

})

Vue.mixin({
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },

    APP_VERSION() {
      return process.env.VUE_APP_VERSION
    },
    isAndroid() {
      return !!this.options.platform && this.options.platform.name.toLowerCase() == 'android'
    },
    isIOS() {
      return !!this.options.platform && this.options.platform.name.toLowerCase() == 'ios'
    },
    isLegacyAndroid() {
      if (this.isAndroid && this.options.sdk) {
       /*  let ver = this.options.platform.version.split('.')
        return ver[0] < 4 || (ver[0] == 4 && ver[1] < 3) */

        return this.options.sdk <= 17
      }
      return false
    }
  },
  data() {
    return {
      options: options
    }
  },
  methods: {
    parseWebViewRoute(route) {

/*       if (route.query.hasOwnProperty('wire')) {
        this.options.token = route.query.wire
      }
 */
      this.options.initRouteName = route.name

      if (route.query.mode == 'dark') {
         this.$vuetify.theme.dark = true 
      }

      if (route.query.hasOwnProperty('ios')) {
        this.options.platform = { name: 'ios', version: route.query['ios'] }
      }

      if (route.query.hasOwnProperty('android')) {
        this.options.platform = { name: 'android', version: route.query['android'] }
      }

      if (route.query.hasOwnProperty('sdk')) {
        this.options.sdk = route.query['sdk']
      }

    }
  } 
})

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
